import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { notFoundEntrypoint } from '@jira/spa-apps__error-pages-not-found/src/notFoundEntrypoint.entrypoint.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsPerformanceReleaseProjectLimitRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsPerformanceReleaseProjectLimitRoute.tsx';
import { releaseProjectLimitMetricDetailEntryPoint } from './ui/spa/admin-pages/performance/metric-detail/release/project-limit/ReleaseProjectLimitEntryPoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const notFoundPageEntrypoint = createPageEntryPoint({
	main: notFoundEntrypoint,
});

export const globalSettingsPerformanceReleaseProjectLimitRouteEntry: Route = createEntry(
	globalSettingsPerformanceReleaseProjectLimitRoute,
	() => ({
		group: 'global-settings',

		canTransitionIn: () => fg('slt1-1398_site_optimizer_release_metric'),

		entryPoint() {
			if (!fg('slt1-1398_site_optimizer_release_metric')) {
				return notFoundPageEntrypoint;
			}
			return releaseProjectLimitMetricDetailEntryPoint;
		},

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],

		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
